import { h, Component } from 'preact';
// import {JavaScriptIcon, ReactIcon, ReduxIcon, FirebaseIcon, NodeIcon, ExpressIcon, GithubIcon} from './../Icons'

export default class ImageUploader extends Component {
	render() {
		return (
      <div>

				<div class="Container">

					<br />
					<br />


					<div class="Product">
						<div class="info">
							<div class="Title">
								<span class="text">Image Uploader Client</span>
							</div>
							<p>
								Client side application for taking and uploading photos. Built with React.
							</p>
						</div>
						<div class="Image shadow border">
							<img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/iu-client2.png?alt=media&token=3f1e16c1-0786-4d2d-9688-bfe258878b9f" style={{ border: 'none', boxShadow: 'none', height: '360px', width: 'auto' }} alt="Image Upload Client" />
						</div>
					</div>
				</div>

				<br />
				<br />

				<div class="Container">
					<div class="Product">
						<div class="Image shadow border">
						<img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/iu-admin.png?alt=media&token=5569bbdd-b3b1-44fd-af2f-751a107dbe5a" style={{ border: 'none', boxShadow: '0px 0px 26px #eee' }} alt="Image Upload Client" />
						</div>
						<div class="info">
							<div class="Title">
								<span class="text">Image Uploader Admin</span>
							</div>
							<p>
								Lists customer photo requests. Ruby on Rails.
							</p>
						</div>
					</div>
				</div>

				<br />
				<br />

				<div class="Container">
					<div class="Product">
						<div class="info">
							<div class="Title">
								<span class="text">Customer Order page</span>
							</div>
							<p>
								Designed and built a new order page. Features include: Shipment Status, view and accept order photos. Made with Shopify Liquid.
							</p>
						</div>
						<div class="Image shadow border">
							<img src="https://firebasestorage.googleapis.com/v0/b/homepage-b9f4a.appspot.com/o/iu-order.png?alt=media&token=8d86a67f-71d0-48eb-a86b-e6ed4638e223" style={{ border: 'none', boxShadow: '0px 0px 26px #eee', height: '360px', width: 'auto' }} alt="Image Upload Client" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/imageuploader/index.js